module.exports = __webpack_public_path__ + "static/media/ts12tj0.1aa67102.png";